import { useNetwork } from '@vueuse/core';
import type { PaymentInitReport } from '../interfaces/paymentInit.interface';
import { isCodeDefect } from '../../shared/utils/paymentFailure';
import { describeInitError } from '../utils/paymentInitError';

export function usePaymentInitReport() {
  const { $logger, $releaseVersion } = useNuxtApp();
  const { gatewayType } = useHelpers();
  const { isOnline } = useNetwork();
  const { track } = useEventsDispatcher();

  function reportPaymentInit({ outcome, action, attempts, error }: PaymentInitReport): void {
    try {
      track('Payment Init', {
        outcome,
        action,
        'gateway': gatewayType.value,
        attempts,
        'offline': !isOnline.value,
        'cause': error === undefined ? undefined : describeInitError(error),
        'Release version': $releaseVersion,
      });
    } catch (trackingError: unknown) {
      $logger.note({
        category: 'analytics',
        message: 'tracking the payment init outcome failed',
        level: 'warning',
        cause: trackingError,
      });
    }

    if (isCodeDefect(error)) {
      $logger.error(error, {
        tags: {
          flow: 'payment',
          gateway: gatewayType.value,
          init_action: action,
          init_outcome: outcome,
        },
      });
    }
  }

  return { reportPaymentInit };
}
